import {
  BulkGrantResponse,
  CampaignResponse,
  CompanyResponse,
  ShopResponse,
  TerminalResponse,
  WalletServiceResponse,
} from '@/repositories/generated';
import {
  string,
  date,
  object,
  array,
  AnyObject,
} from '@/validations/custom-yup';

// 1年(366日)のミリ秒
export const oneYearMs = 366 * 24 * 60 * 60 * 1000;

/** 集計期間 */
export const aggregationStartDateTimeSchema = date()
  .label('開始日')
  .required()
  .transform((value, originalValue) => (originalValue instanceof Date ? value : undefined));

export const aggregationEndDateTimeSchema = date()
  .label('終了日')
  .required()
  .transform((value, originalValue) => (originalValue instanceof Date ? value : undefined))
  .when(
    'startDateTime',
    ([startDateTime], schema) => schema
      .test(
        '終了日が開始日以降か',
        '終了日は開始日以降の日付を入力してください。',
        (value) => (
          value == null || startDateTime == null
            ? true
            : startDateTime.getTime() <= value.getTime()
        ),
      )
      .test(
        '開始日と終了日が1年以内か',
        '集計期間は1年以下に設定してください。',
        (value) => {
          if (value == null || startDateTime == null) return true;

          const startDateTimeEndDateTimeDiff = value.getTime() - startDateTime.getTime();
          return startDateTimeEndDateTimeDiff < oneYearMs;
        },
      ),
  );

export const aggregationWalletServicesMaxLength = 30;
export const aggregationWalletServicesSchema = array<AnyObject, WalletServiceResponse>(object({
  id: string()
    .required(),
  name: string()
    .required(),
})
  .required())
  .label('ウォレットサービス')
  .default([])
  .max(aggregationWalletServicesMaxLength);

export const aggregationCompaniesMaxLength = 50;
export const aggregationCompaniesSchema = array<AnyObject, CompanyResponse>(object({
  id: string()
    .required(),
  name: string()
    .required(),
})
  .required())
  .label('企業')
  .default([])
  .max(aggregationCompaniesMaxLength);

export const aggregationShopsMaxLength = 10000;
export const aggregationShopsSchema = array<AnyObject, ShopResponse>(object({
  id: string()
    .required(),
  name: string()
    .required(),
})
  .required())
  .label('店舗')
  .default([])
  .max(aggregationShopsMaxLength);

export const aggregationTerminalsMaxLength = 20000;
export const aggregationTerminalsSchema = array<AnyObject, TerminalResponse>(object({
  id: string()
    .required(),
})
  .required())
  .label('端末')
  .default([])
  .max(aggregationTerminalsMaxLength);

export const aggregationBulkGrantsMaxLength = 1000;
export const aggregationBulkGrantsSchema = array<AnyObject, BulkGrantResponse>(object({
  id: string()
    .required(),
  systemName: string()
    .required(),
})
  .required())
  .label('管理名称')
  .default([])
  .max(aggregationBulkGrantsMaxLength);

export const aggregationCampaignsMaxLength = 1000;
export const aggregationCampaignsSchema = array<AnyObject, CampaignResponse>(object({
  id: string()
    .required(),
  name: string()
    .required(),
})
  .required())
  .label('管理名称')
  .default([])
  .max(aggregationCampaignsMaxLength);

export const aggregationOutputPatternSchema = string()
  .required();
